/*
 * @Description: In User Settings Edit
 * @Author: lic
 * @Date: 2019-07-31 14:21:04
 * @LastEditTime: 2019-10-22 02:03:30
 * @LastEditors: Please set LastEditors
 */
/**
 * 数字转金额（千分位+小数点后两位）
 */
export function formatCurrency (num) {
  if (num !== null && num !== undefined && num !== '') {
    if (isNaN(num)) num = '0'
    var sign = num === (num = Math.abs(num))
    num = Math.floor(num * 100 + 0.50000000001)
    var cents = num % 100
    num = Math.floor(num / 100).toString()
    if (cents < 10) cents = '0' + cents
    for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
      num =
        num.substring(0, num.length - (4 * i + 3)) +
        ',' +
        num.substring(num.length - (4 * i + 3))
    }
    return (sign ? '' : '-') + num + '.' + cents
  } else {
    return '0.00'
  }
}
/* eslint-disable */
export function appShareClick() {
  console.log(localStorage.getItem('USER_DEVICE_TYPE'))
  if (localStorage.getItem('USER_DEVICE_TYPE') == 1) {
    // 平果
    clickShareBtn('hello')
  }
  if (localStorage.getItem('USER_DEVICE_TYPE') == 2) {
    // 安卓
    window.android.clickShareBtn('hello')
  }
}

export function appCertificationClick() {
  console.log(localStorage.getItem('USER_DEVICE_TYPE'))
  if (localStorage.getItem('USER_DEVICE_TYPE') == 1) {
    // 平果
    clickCertificationBtn('hello')
  }
  if (localStorage.getItem('USER_DEVICE_TYPE') == 2) {
    // 安卓
    window.android.clickCertificationBtn('hello')
  }
}
/* eslint-enable */
/**
 * 时间戳转换年月日 时分秒
 */
export function jsonDateFormat (jsonDate, type) {
  if (jsonDate) {
    var timeStamp
    if (jsonDate.toString().length === 10) {
      timeStamp = jsonDate * 1000
    } else {
      timeStamp = jsonDate
    }
    var time = new Date(timeStamp)
    var y = time.getFullYear()
    var m =
      time.getMonth() + 1 < 10
        ? '0' + (time.getMonth() + 1)
        : time.getMonth() + 1
    var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
    var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
    var mm =
      time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
    var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
    if (type === 'date') {
      return y + '-' + m + '-' + d
    }
    if (type === 'date2') {
      return y + '.' + m + '.' + d
    }
    if (type === 'time') {
      return y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s
    }
    if (type === 'minute') {
      return y + '.' + m + '.' + d + ' ' + h + ':' + mm
    }
    if (type === 'minute1') {
      return m + '-' + d + ' ' + h + ':' + mm
    }
    if (type === 'minute2') {
      return y + '-' + m + '-' + d + ' ' + h + ':' + mm
    }
  }
}
/**
 * 获取图片新数据
 * @param {*} oldImageArr 老图片列表
 * @param {*} total 总共图片数量
 * @param {*} limit 限制数量
 */
export function getImageList (oldImageArr, total, limit) {
  let arr = []
  let num = 0
  let totalNum = 0
  if (oldImageArr && oldImageArr.length > 0) {
    arr = oldImageArr
  }
  if (arr.length >= limit) {
    return arr
  }
  if (total) {
    totalNum = parseInt(total)
  }
  if (totalNum > limit) {
    totalNum = limit
  }
  num = totalNum - arr.length
  let imageUrl =
    'https://xym-wechat.oss-cn-hangzhou.aliyuncs.com/spread/icon/photo%20%28%s%29.jpeg'
  for (let i = 0; i < num; i++) {
    let randomNum = Math.floor(Math.random() * 959) + 1
    let newUrl = imageUrl.replace('%s', randomNum)
    arr.push(newUrl)
  }
  return arr
}
/**
 * 浮点型的乘法
 * @param {*} a
 * @param {*} b
 */
export function floatMul (a, b) {
  let c = 0
  let d = a.toString()
  let e = b.toString()
  try {
    c += d.split('.')[1].length
  } catch (f) {}
  try {
    c += e.split('.')[1].length
  } catch (f) {}
  return (
    (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c)
  )
}
/**
 * 浮点型的加法
 * @param {*} a
 * @param {*} b
 */
export function floatAdd (a, b) {
  var c, d, e
  try {
    c = a.toString().split('.')[1].length
  } catch (f) {
    c = 0
  }
  try {
    d = b.toString().split('.')[1].length
  } catch (f) {
    d = 0
  }
  e = Math.pow(10, Math.max(c, d))
  return (floatMul(a, e) + floatMul(b, e)) / e
}
/**
 * 浮点型的减法
 * @param {*} a
 * @param {*} b
 */
export function floatSub (a, b) {
  var c, d, e
  try {
    c = a.toString().split('.')[1].length
  } catch (f) {
    c = 0
  }
  try {
    d = b.toString().split('.')[1].length
  } catch (f) {
    d = 0
  }
  e = Math.pow(10, Math.max(c, d))
  return (floatMul(a, e) - floatMul(b, e)) / e
}
/**
 * 浮点型的除法
 * @param {*} a
 * @param {*} b
 */
export function floatDiv (a, b) {
  let c
  let d
  let e = 0
  let f = 0
  try {
    e = a.toString().split('.')[1].length
  } catch (g) {
    e = 0
  }
  try {
    f = b.toString().split('.')[1].length
  } catch (g) {
    f = 0
  }
  c = Number(a.toString().replace('.', ''))
  d = Number(b.toString().replace('.', ''))
  return floatMul(c / d, Math.pow(10, f - e))
}
/**
 * JS~字符串长度判断，超出进行自动截取（支持中文）
 * @param {string} longString
 * @param {int} length
 */
export function getShortStringByLength (longString, length) {
  var GetLength = function (str) {
    /// <summary>获得字符串实际长度，中文2，英文1</summary>
    /// <param name="str">要获得长度的字符串</param>
    var realLength = 0
    var len = str.length
    var charCode = -1
    for (var i = 0; i < len; i++) {
      charCode = str.charCodeAt(i)
      if (charCode >= 0 && charCode <= 128) realLength += 1
      else realLength += 2
    }
    return realLength
  }
  /**
   * js截取字符串，中英文都能用
   * @param str：需要截取的字符串
   * @param len: 需要截取的长度
   */
  function cutstr (str, len) {
    var strLength = 0
    var strLen = 0
    var a
    let strCut = ''
    strLen = str.length
    for (var i = 0; i < strLen; i++) {
      a = str.charAt(i)
      strLength++
      if (escape(a).length > 4) {
        // 中文字符的长度经编码之后大于4
        strLength++
      }
      strCut = strCut.concat(a)
      if (strLength >= len) {
        strCut = strCut.concat('...')
        return strCut
      }
    }
    // 如果给定字符串小于指定长度，则返回源字符串；
    if (strLength < len) {
      return str
    }
  }
  if (GetLength(longString) > length) {
    return cutstr(longString, length)
  } else {
    return longString
  }
}
export function getQueryVariable (variable) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) { return pair[1] }
  }
  return (false)
}
export function setCookie (name, value, expiredays) {
  var exp = new Date()
  exp.setTime(exp.getTime() + expiredays * 24 * 60 * 60 * 1000)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
}
export function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
  }
  return ''
}
export default {
  formatCurrency,
  jsonDateFormat,
  appShareClick,
  floatMul,
  floatAdd,
  floatSub,
  floatDiv,
  getShortStringByLength,
  appCertificationClick,
  getQueryVariable,
  setCookie,
  getCookie
}



// WEBPACK FOOTER //
// ./src/utils/index.js